"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var styles = {
  "chip": "chip-module__chip___OaiCG",
  "selected": "chip-module__selected___QEnid",
  "remove": "chip-module__remove___EFpBx"
};
const Chip = ({
  selected,
  onRemove,
  children
}) => {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(styles.chip, {
      [styles.selected]: selected
    })
  }, children, /*#__PURE__*/_react.default.createElement("span", {
    className: styles.remove,
    onClick: onRemove
  }, " \xD7"));
};
Chip.propTypes = {
  selected: _propTypes.default.bool,
  onRemove: _propTypes.default.func
};
Chip.defaultProps = {
  selected: false
};
var _default = exports.default = Chip;